import { render, staticRenderFns } from "./ProductEditTabAccount.vue?vue&type=template&id=7614851a&"
import script from "./ProductEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports